var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs flex flex-row"},_vm._l((_vm.tabs),function(tab){return _c('x-tab',{key:tab.id,attrs:{"active":_vm.isActive(tab)},on:{"click":function($event){_vm.selected = tab.id}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }